import axios from 'axios';

// Configure axios to include credentials
axios.defaults.withCredentials = true;

// Use the proxy instead of the full URL
const API_URL = '/api';

// Get all field mappings
export const getFieldMappings = async () => {
  try {
    const response = await axios.get(`${API_URL}/field-mappings`);
    return response.data;
  } catch (error) {
    console.error('Error fetching field mappings:', error);
    throw error;
  }
};

// Save field mappings
export const saveFieldMappings = async (mappings) => {
  try {
    // Ensure we're only sending the necessary fields to the server
    const simplifiedMappings = mappings.map(({ opportunityField, hubspotField }) => ({
      opportunityField,
      hubspotField
    }));
    
    const response = await axios.post(`${API_URL}/field-mappings`, { 
      mappings: simplifiedMappings 
    });
    
    return response.data;
  } catch (error) {
    console.error('Error saving field mappings:', error);
    throw error;
  }
};

// Test field mappings with HubSpot
export const testFieldMappings = async (mappings) => {
  try {
    console.log('Testing field mappings:', mappings);
    
    // Ensure we're only sending the necessary fields to the server
    const simplifiedMappings = mappings.map(({ opportunityField, hubspotField }) => ({
      opportunityField,
      hubspotField
    }));
    
    const response = await axios.post(`${API_URL}/field-mappings/test`, { 
      mappings: simplifiedMappings 
    });
    
    return response.data;
  } catch (error) {
    console.error('Error testing field mappings:', error);
    throw error;
  }
};

// Get HubSpot contact properties
export const getHubspotContactProperties = async () => {
  try {
    const response = await axios.get(`${API_URL}/hubspot/contact-properties`);
    
    // Sort properties by label for easier selection
    const sortedProperties = response.data.sort((a, b) => 
      a.label.localeCompare(b.label)
    );
    
    return sortedProperties;
  } catch (error) {
    console.error('Error fetching HubSpot contact properties:', error);
    throw error;
  }
};

// Get opportunity fields
export const getOpportunityFields = async () => {
  try {
    const response = await axios.get(`${API_URL}/hubspot/opportunity-fields`);
    return response.data;
  } catch (error) {
    console.error('Error fetching opportunity fields:', error);
    throw error;
  }
}; 